/**
 * journey-ux/FilterChips.jsx — chip-row filter primitive (Phase 1)
 *
 * Renders an always-visible row of filter chips above a DataGrid.
 * Used to replace hidden filter modals in dense operational lists.
 *
 *   <FilterChips
 *     chips={[
 *       { id: 'all',     label: 'All',     count: 47 },
 *       { id: 'mine',    label: 'Mine',    count: 19 },
 *       { id: 'blocked', label: 'Blocked', count: 8 },
 *     ]}
 *     activeId="all"
 *     onChange={setFilter}
 *     resultLabel="47 cases"
 *   />
 */
import React from 'react';

export const FilterChips = ({
  chips = [],
  activeId,
  onChange,
  resultLabel,
  testIdPrefix = 'filter-chip',
  rightSlot = null,
}) => (
  <div
    data-testid={`${testIdPrefix}-row`}
    className="px-5 py-2 border-b border-slate-100 bg-white flex items-center gap-1.5 overflow-x-auto"
  >
    {chips.map((c) => {
      const active = c.id === activeId;
      return (
        <button
          key={c.id}
          type="button"
          onClick={() => onChange && onChange(c.id)}
          data-testid={`${testIdPrefix}-${c.id}`}
          className={`text-[11px] px-2 py-1 rounded inline-flex items-center gap-1.5 transition-colors ${
            active
              ? 'bg-slate-900 text-white'
              : 'bg-white text-slate-700 border border-slate-200 hover:border-slate-300'
          }`}
        >
          <span>{c.label}</span>
          {c.count !== undefined && c.count !== null && (
            <span className="text-[10px] opacity-70">{c.count}</span>
          )}
        </button>
      );
    })}
    {resultLabel && (
      <span
        data-testid={`${testIdPrefix}-result-label`}
        className="text-[11px] text-slate-500 ml-auto pr-1"
      >
        {resultLabel}
      </span>
    )}
    {rightSlot && <div className={resultLabel ? '' : 'ml-auto'}>{rightSlot}</div>}
  </div>
);

export default FilterChips;
